import { Box, Icon, ScrollView, Text } from '@betty/moonlight';
import { memo, useCallback } from 'react';
import { RG_SECTIONS } from './ResponsibleGaming.constants';
import { Linking, Pressable } from 'react-native';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { Trans, useTranslation } from '@betty/i18n';

function ResponsibleGaming() {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const { t } = useTranslation('responsibleGaming');

  const handlePress = useCallback(
    (screen: string) => {
      navigation.navigate(screen);
    },
    [navigation],
  );

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <Box
        gap="space-800"
        width="100%"
        marginTop="space-400"
        marginBottom="space-800"
      >
        <Text variant="body-m-semi" color="darkSurfacePrimary">
          <Trans
            ns="responsibleGaming"
            i18nKey="mainTitle"
            components={[
              <Text
                key="link"
                variant="body-m-semi"
                color="darkSurfacePrimary"
                underline
                onPress={() =>
                  Linking.openURL('https://www.connexontario.ca/en-ca/')
                }
              />,
            ]}
          />
        </Text>
        {RG_SECTIONS.map(({ title, description, navigateScreen }, index) => (
          <Pressable key={index} onPress={() => handlePress(navigateScreen)}>
            <Box
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box gap="space-200" flex={1}>
                <Text variant="h5" color="darkSurfacePrimary">
                  {t(title)}
                </Text>
                <Text variant="body-m-semi" color="darkSurfacePrimary">
                  {t(description)}
                </Text>
              </Box>
              <Icon
                name="arrowForward"
                gradient="accentBackground"
                height={16}
                width={21}
              />
            </Box>
          </Pressable>
        ))}
      </Box>
    </ScrollView>
  );
}

export default memo(ResponsibleGaming);
